// extracted by mini-css-extract-plugin
module.exports = {"employeeStatus":"EmployeeStatus_employeeStatus__DqFqj","editButton":"EmployeeStatus_editButton__31nsD"};